module.exports = __webpack_public_path__ + "static/media/logo.344e3f6d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo.png
// module id = 1569
// module chunks = 0